import { AffiliateDeposit, AffiliateStatus } from "./Affiliate";
import { Coupon, CouponType } from "./Coupon";
import { EnableablePreference } from "./EnableablePreference";
import { MembershipPurchaseItem } from "./MembershipPurchaseItem";
import { RewardCode } from "./RewardCode";
import { SelectedExperiences } from "./SelectedExperiences";

export interface CouponCode extends RewardCode {
    coupon?: Coupon;
}

export interface CouponCodeWithCoupon extends Omit<CouponCode, "coupon"> {
    coupon: Coupon;
}

export enum CouponCodeStatus {
    ACTIVE = 100,
    REDEEMED = 200,
    VOID = 400,
}

export const CouponCodeStatusCopy: { [key in number]: string } = {
    [CouponCodeStatus.ACTIVE]: "Active",
    [CouponCodeStatus.REDEEMED]: "Redeemed",
    [CouponCodeStatus.VOID]: "Void",
};

export enum CouponCodeDuplicateOption {
    SKIP = "skip",
    VOID = "void",
}

export type CreateCouponCode = Pick<CouponCode, "code">;

// TODO: Check if `ApplyCode` and `ApplyCouponCode` types are the same
export interface ApplyCode {
    amount: string;
    type: CouponType;
    id: ID;
    name: string;
    code: string;
    children?: string[];
    parent?: string;
    delegated: boolean;
    affiliateNotification?: EnableablePreference;
    travelerNotification?: EnableablePreference;
    deposit?: AffiliateDeposit;
    voucher?: boolean;
    purchaseRulesPermanentIds?: string[];
    purchaseRules?: Array<{ id: ID }>;
    status: number | AffiliateStatus;
    experiences?: SelectedExperiences;
    coupon?: Coupon;
    object?: string;
    membershipItem?: MembershipPurchaseItem;
}
